<template>
    <div class="container mt-5">
        <div class="card p-4" v-if="store.getters.hasPermission('updateAccount')">
            <div class="row mb-3">
                <div class="col-12">
                    <AccountForm
                        @submit="updateAccount"
                        :errors="updateAccountErrors"
                        :loading="isUpdateLoading"
                        :default-values="store.state.user"
                    />
                </div>
            </div>
        </div>

        <div class="card p-4" v-if="store.getters.hasPermission('updatePassword')">
            <div class="row mb-3">
                <div class="col-12">
                    <UpdatePasswordForm />
                </div>
            </div>
        </div>

        <div class="card p-4" v-if="store.getters.hasPermission('deleteAccount')">
            <div class="row mb-3">
                <div class="col-12">
                    <DeleteAccountForm @deleted="deleted" />
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
    import DeleteAccountForm from '../forms/DeleteAccountForm.vue';
    import { inject, ref } from 'vue';
    import { notifyError, notifySuccess } from '../utils/notify';
    import { AccountService } from '../services/accountService';
    import i18n from '../utils/locale';
    import AccountForm from '../forms/AccountForm.vue';
    import UpdatePasswordForm from '../forms/UpdatePasswordForm.vue';
    import { IpcCall, ipcCall } from '../lite/utils/ipcCall';
    import { useRouter } from 'vue-router/composables';

    const router = useRouter();
    const store = inject('store');

    const isUpdateLoading = ref(false);

    const updateAccountErrors = ref(null);

    async function updateAccount(data) {
        isUpdateLoading.value = true;
        updateAccountErrors.value = null;

        try {
            const response = await AccountService.getInstance().updateAccount(data);

            await store.dispatch('updateUser', {
                user: response.data,
            });

            notifySuccess(i18n.t('account.wijziging_opgeslagen'));
        } catch (exception) {
            updateAccountErrors.value = exception?.response?.data?.errors || null;
            notifyError(exception);
        } finally {
            isUpdateLoading.value = false;
        }
    }

    async function deleted() {
        await store.dispatch('logout');
        await router.push('/login?deleted_account');

        await ipcCall(IpcCall.Logout);
    }

</script>
